module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-bg login-bg",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6"
  }, [_c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-content text-center"
  }, [(_vm.verifying) ? _c('div', [_c('p', {
    staticClass: "m-b-lg lead"
  }, [_vm._v("\n                Please wait a moment while we verify your account...\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  })]) : _c('div', [_c('div', {
    staticClass: "swal2-show"
  }, [(_vm.success) ? _c('div', {
    staticClass: "swal2-icon swal2-success swal2-animate-success-icon",
    staticStyle: {
      "display": "block",
      "margin-top": "0",
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "swal2-success-circular-line-left",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "swal2-success-line-tip swal2-animate-success-line-tip"
  }), _vm._v(" "), _c('span', {
    staticClass: "swal2-success-line-long swal2-animate-success-line-long"
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-ring"
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-fix",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-circular-line-right",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  })]) : _c('div', {
    staticClass: "swal2-icon swal2-error swal2-animate-error-icon",
    staticStyle: {
      "display": "block",
      "margin-top": "0",
      "margin-bottom": "20px"
    }
  }, [_c('span', {
    staticClass: "swal2-x-mark swal2-animate-x-mark"
  }, [_c('span', {
    staticClass: "swal2-x-mark-line-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "swal2-x-mark-line-right"
  })])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('h1', [_vm._v("Verifying Account")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-44d8c046"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Verification.vue
// module id = 981
// module chunks = 0